
export class Breadcrumb {

    constructor(
        public title: string = '',
        public link: string = '',
    ) { }

}
